import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const CompanySelectorPage = lazy(
  () => import('modules/authentication/pages/CompanySelectorPage')
)
const RootPage = lazy(() => import('modules/authentication/pages/RootPage'))

export const authenticationRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.authentication.path,
      element: <RootPage />,
      handle: {
        module: 'authentication',
      },
      children: [
        {
          path: navigation.authentication.company_selector.path,
          element: <CompanySelectorPage />,
        },
      ],
    },
  ]
}
